module.exports = __webpack_public_path__ + "img/Avatar-21.b39d0050.svg";